module.exports = __webpack_public_path__ + "static/About-Hero-2156bb974c7e8720402295edb68a11fd.jpg";